import React from 'react';
import PropTypes from 'prop-types';
import SectionBadge from '../SectionBadge';
import {
  IconWhatsApp,
  IconCalendar,
  IconAiPresentationChart,
  IconAiMagicHat,
  IconAiPencil2,
  IconUserSquare,
} from 'gatorcomponents';
import * as Styles from './Features.styles';

const featureIcons = [
  IconWhatsApp,
  IconCalendar,
  IconAiPresentationChart,
  IconAiMagicHat,
  IconAiPencil2,
  IconUserSquare,
];

const Features = ({ locale }) => (
  <Styles.Section>
    <Styles.BadgeWrapper>
      <SectionBadge text={locale.badge} />
    </Styles.BadgeWrapper>

    <Styles.Title>
      {locale.title}
    </Styles.Title>

    <Styles.Subtitle>{locale.subtitle}</Styles.Subtitle>

    <Styles.CardsGrid>
      {locale.cards?.map((card, index) => {
        const Icon = featureIcons[index];
        return (
          <Styles.Card key={card.title}>
            <Styles.IconPlaceholder>
              {Icon && <Icon gradient="tertiary" />}
            </Styles.IconPlaceholder>
            <Styles.CardContent>
              <Styles.CardTitle>{card.title}</Styles.CardTitle>
              <Styles.CardText>{card.text}</Styles.CardText>
            </Styles.CardContent>
          </Styles.Card>
        );
      })}
    </Styles.CardsGrid>
  </Styles.Section>
);

Features.propTypes = {
  locale: PropTypes.shape({
    badge: PropTypes.string,
    titleNormal: PropTypes.string,
    titleGradient: PropTypes.string,
    titleNormalEnd: PropTypes.string,
    subtitle: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
      }),
    ),
  }).isRequired,
};

export default Features;
